<!-- Header -->
<h3 mat-dialog-title translate>
    Option Not Available
</h3>

<!-- Body -->
<mat-dialog-content translate>
    This option is not available because there is no email<br />
    address on file for you. Please contact the school<br />
    and provide the neccesary information.
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button image="save.png" label="OK" (clickEvent)="ok()"></tyl-button>
    </div>
</mat-dialog-actions>